import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../base-api.service';
import {DevicesModelService} from '../../Models/Core/devices-model.service';
import {DeviceStoreForm} from '../../../Models/Device/device-store.model';

@Injectable({
  providedIn: 'root'
})
export class DevicesApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: DevicesModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener los dispositivos
   *
   */
  public getDevices(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getDispositivos', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar nuevo dispositivo
   *
   */
  public setDevice(params: DeviceStoreForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setDispositivo', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Activar/Desactivar un dispositivo
   *
   */
  toggleDevice(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('toggleActivoDispositivo', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Eliminar un dispositivo
   *
   */
  deleteDevice(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteDispositivo', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
